import * as AT from '../constants/actionTypes'

/**
 * Switching pages after certain actions (navigate via history).
 * @param {object} history - history instance from createBrowserHistory()
 */
const PageMiddleware = (history) => store => next => action => {
	next(action);
	switch (action.type) {
		case AT.PANELCHANGE_ADD_TARGET_FINISHED:
		case AT.PANELCHANGE_REMOVE_TARGET_FINISHED:
		case AT.REQUEST_ADD_NEW_TARGET_FINISHED:
		case AT.REQUEST_ADD_EXISTING_ADDRESS_FINISHED:
		case AT.REQUEST_ADD_NEW_ADDRESS_FINISHED:
			history.push('/showChanges');
			break;
		case AT.PANELCHANGE_MODIFY_TARGET_FINISHED:
			history.push('/panelChanges');
			break;
		case AT.UPLOAD_FILE_FINISHED:
			history.push('/admin/requestsAndChanges');
			break;
		default:
			break;
	}
};

export default PageMiddleware